import { ComponentUtil } from '../../utils/ComponentUtil';
import { Hooks } from '../../types/Hooks';

ComponentUtil.loader(
  !!document.querySelector(Hooks.AccordionRoot),
  () => import('./Accordion'),
  (Accordion) => {
    ComponentUtil.binder(Hooks.AccordionRoot, Accordion);
  },
);
